export const cities = [
    {
        "area": "160.85",
        "coords": {
            "lat": "50.77556",
            "lon": "6.08361"
        },
        "district": "Aachen",
        "name": "Aachen",
        "population": "248878",
        "state": "North Rhine-Westphalia"
    },
    {
        "area": "10.69",
        "coords": {
            "lat": "47.84556",
            "lon": "8.85167"
        },
        "district": "Konstanz",
        "name": "Aach",
        "population": "2314",
        "state": "Baden-Württemberg"
    },
    {
        "area": "146.63",
        "coords": {
            "lat": "48.833",
            "lon": "10.100"
        },
        "district": "Ostalbkreis",
        "name": "Aalen",
        "population": "68361",
        "state": "Baden-Württemberg"
    },
    {
        "area": "48.39",
        "coords": {
            "lat": "49.250",
            "lon": "10.967"
        },
        "district": "Roth",
        "name": "Abenberg",
        "population": "5492",
        "state": "Bavaria"
    },
    {
        "area": "60.29",
        "coords": {
            "lat": "48.800",
            "lon": "11.850"
        },
        "district": "Kelheim",
        "name": "Abensberg",
        "population": "14192",
        "state": "Bavaria"
    },
    {
        "area": "65.24",
        "coords": {
            "lat": "48.633",
            "lon": "8.067"
        },
        "district": "Ortenaukreis",
        "name": "Achern",
        "population": "25615",
        "state": "Baden-Württemberg"
    },
    {
        "area": "68.01",
        "coords": {
            "lat": "53.06528",
            "lon": "9.03417"
        },
        "district": "Verden",
        "name": "Achim",
        "population": "32084",
        "state": "Lower Saxony"
    },
    {
        "area": "43.84",
        "coords": {
            "lat": "49.40472",
            "lon": "9.38917"
        },
        "district": "Neckar-Odenwald-Kreis",
        "name": "Adelsheim",
        "population": "5099",
        "state": "Baden-Württemberg"
    },
    {
        "area": "18.56",
        "coords": {
            "lat": "50.383",
            "lon": "6.933"
        },
        "district": "Ahrweiler",
        "name": "Adenau",
        "population": "2955",
        "state": "Rhineland-Palatinate"
    }]


    //6LdZLO8fAAAAAF74CKt5Y_CTuaolPyWhkNjlAxyJ
    //6LdZLO8fAAAAALO7A8XbIm0gPlnsTJ2c03d1l0Mv